._gapBox_18laq_1 {
  position: absolute;
  background: rgba(220, 233, 255, 0.4); }
  ._gapBox_18laq_1._isResizing_18laq_4 > ._resizeHandle_18laq_4 {
    width: 100%;
    height: 100%; }
    ._gapBox_18laq_1._isResizing_18laq_4 > ._resizeHandle_18laq_4::after {
      opacity: 0; }
  ._gapBox_18laq_1._isResizing_18laq_4, ._gapBox_18laq_1:has(._resizeHandle_18laq_4:hover) {
    background: rgba(195, 218, 255, 0.6); }

._resizeHandle_18laq_4 {
  width: 72px;
  height: 28px;
  cursor: row-resize; }
  ._resizeHandle_18laq_4::after {
    display: block;
    content: '';
    width: 18px;
    height: 3px;
    border-radius: 30px;
    background: #116dff;
    border: 1px solid #ffffff; }

._heightInput_18laq_25 {
  max-width: 60px; }

._heightIndication_18laq_28 {
  width: 30px;
  height: 14px;
  border-radius: 2px;
  background-color: #116dff; }
  ._heightIndication_18laq_28 span {
    font-size: 10px;
    font-weight: 600;
    font-family: var(--wbu-font-stack);
    color: #ffffff;
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%); }

._heightInput_18laq_25,
._heightIndication_18laq_28 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(15px, -50%); }

._resizeHandle_18laq_4,
._heightInput_18laq_25 {
  z-index: 1000; }

._gapBox_18laq_1,
._resizeHandle_18laq_4 {
  display: flex;
  align-items: center;
  justify-content: center; }
